const config = {
  coreBaseUrl:
    process.env.VUE_APP_IS_STANDALONE === "true"
      ? process.env.VUE_APP_BASE_URL
      : window.location.origin + "/",
  token: null,
  refreshToken: null,
  selectedLocation: localStorage.getItem("selectedLocation")
};

export default config;
